import { Component, OnInit, ViewChild } from '@angular/core';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonMenu, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from './services';
import { AppConfigStore } from './stores/app-config.store';
import { DaysPlannerStore } from './stores/day-planner.store';
import { UiStore } from './stores/ui.store';
import { Storage } from '@ionic/storage-angular';
import { LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('menu', { read: IonMenu }) menu: IonMenu;
  
  public selectedIndex = 0;
  public appPages = [
    // {
    //   title: 'home',
    //   url: '/',
    //   icon: 'home'
    // },
    {
      title: 'detoxPlan',
      url: '/detox',
      icon: 'calendar'
    },

    {
      title: 'guides',
      url: '/guides',
      icon: 'book'
    },
    // {
    //   title: 'shoppingList',
    //   url: '/shopping-list',
    //   icon: 'cart'
    // },
    {
      title: 'aboutUs',
      url: '/about-us',
      icon: 'people'
    },
    {
      title: 'termsOfUse',
      url: '/terms-of-use',
      icon: 'alert'
    },
    {
      title: 'settings',
      url: '/settings',
      icon: 'settings'
    },
  ];
  public labels = [];//['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  constructor(
    private translate: TranslateService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public uiStore: UiStore,
    public appConfigStore: AppConfigStore,
    public daysPlannerStore: DaysPlannerStore,
    private langService: LangService,
    private storage: Storage,
    private loadingController: LoadingController
  ) {

    this.getData();
    //this.initializeApp();
  }

  // initializeApp() {
  //   this.langService.setLangTranslation('en');
  //   this.translate.setDefaultLang('en');
  //   this.translate.use('en');

  //   this.platform.ready().then(() => {
  //     this.statusBar.styleDefault();
  //     this.splashScreen.hide();
  //   });

  //   this.daysPlannerStore.loadDaysPlanner('0');



  // }

  async getData() {

    await this.presentLoading();

    // if (!(this.uiStore && this.uiStore.currentLang && this.uiStore.currentPlan)) {
    //   debugger
    //   setTimeout(() => {
    //     this.getData()
    //   }, 1500);
    //   return;
    // }

    // 64539e705b82984b5dc862d1 => L.RAPHAEL 21 days detox
    let appConfigURL = `https://eatgood-ronit-server.herokuapp.com/app-settings/64539e705b82984b5dc862d1`;
    const configResponse: any = await (await fetch(appConfigURL)).json();
    const appConfig: any = JSON.parse(configResponse.appConfig);

    // const plansByLanguage = {
    //   "he": {
    //     "standard": "628a34eb5e4961302a58e2bd",
    //     "vegan": "62b2f4a241a2af66329bbafe",
    //     "vegetarian": "62b2f4ab41a2af66329bbb07",
    //     "pescetarian": "62b2f4b241a2af66329bbb10",
    //   },
    //   "en": {
    //     "standard": "628a29c3d3f2989c3ef24379",
    //   }
    // }

    ///debugger
    this.storage.create();

    await this.storage.get('defaultLang').then((val) => {

      this.uiStore.setLang(val || appConfig.defaultLang);
    });
    await this.storage.get('defaultUnit').then((val) => {
      this.uiStore.defaultUnit = val || appConfig.defaultUnit;
    });
    await this.storage.get('currentPlan').then((val) => {
      this.uiStore.currentPlan = val || appConfig.defaultPlan;
    });


    this.uiStore.setDisplayLangs(appConfig.displayLangs);

    console.log(this.uiStore)


    let detoxId = appConfig[this.uiStore.currentLang][this.uiStore.currentPlan]
    ///debugger
    if (!detoxId) {
      detoxId = appConfig["en"]["standard"]
    }

    let days21JsonURL = `https://eatgood-ronit-server.herokuapp.com/detox/${detoxId}`;
    const response: any = await (await fetch(days21JsonURL)).json();




    // "defaultLang": "en",
    //   "defaultPlan": "standard"




    this.uiStore.setDetoxData(response);

    await this.dismissLoading();
  }
 
  async presentLoading() {
    const loading = await this.loadingController.create({
      // duration can be set if you want the loader to dismiss automatically
      // duration: 2000,
      spinner: 'crescent', // choose the spinner style
      cssClass: 'transparent-loader',
    });
    await loading.present();
  }
  async dismissLoading() {
    await this.loadingController.dismiss();
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }
}
